import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import SearchResults from 'help/components/search_results';
import { searchHelp } from 'help/ducks/search';

export function mapStateToProps({ help: { search } }) {
  return {
    ...search
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { searchStr } = params;
  return bindActionCreators({
    search: partial(searchHelp, searchStr),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchResults));



// WEBPACK FOOTER //
// ./help/containers/search_results.js